module.exports = __webpack_public_path__ + "img/arh_1.31ef30ae.jpg";